import { IdentifierDTO } from '@zazume/zzm-base';

import { PhoneCall } from '#/models/phoneCall/PhoneCall';

import { doGet } from '../../helpers';

export const phoneCalls = {
  getById: (id: IdentifierDTO) => () => doGet<PhoneCall>(`/dashboard/phone-calls/${id}`)
};
